// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_wrk_settings = require("../worker/MM_wrk_settings.res.js");
var Expln_React_Menu = require("../../rescript-utils/main/react-mui-components/Expln_React_Menu.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var MM_wrk_search_asrt = require("../worker/MM_wrk_search_asrt.res.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var Select = require("@mui/material/Select").default;
var MM_cmp_pe_frame_list = require("./MM_cmp_pe_frame_list.res.js");
var MM_cmp_asrts_per_page = require("./MM_cmp_asrts_per_page.res.js");
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var Menu = require("@mui/icons-material/Menu").default;
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var FilterAlt = require("@mui/icons-material/FilterAlt").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;
var FilterAltOff = require("@mui/icons-material/FilterAltOff").default;

function propsAreSame(a, b) {
  if (a.preCtxData === b.preCtxData) {
    return a.ctxSelectorIsExpanded === b.ctxSelectorIsExpanded;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var addAsrtByLabel = param.addAsrtByLabel;
        var initPatternFilterStr = param.initPatternFilterStr;
        var ctxSelectorIsExpanded = param.ctxSelectorIsExpanded;
        var toggleCtxSelector = param.toggleCtxSelector;
        var openExplorer = param.openExplorer;
        var preCtxData = param.preCtxData;
        var modalRef = param.modalRef;
        var settings = preCtxData.settingsV.val;
        var preCtx = preCtxData.ctxV.val;
        var match = React.useState(function () {
              return preCtxData.ctxV.ver;
            });
        var setPreCtxVer = match[1];
        var match$1 = React.useState(function () {
              return MM_wrk_settings.settingsGetTypeColors(settings);
            });
        var setTypeColors = match$1[1];
        var match$2 = React.useState(function () {
              return [];
            });
        var setAllLabels = match$2[1];
        var allLabels = match$2[0];
        var match$3 = React.useState(function () {
              return [];
            });
        var setFilteredLabels = match$3[1];
        var match$4 = React.useState(function () {
              return [];
            });
        var setAllStmtTypes = match$4[1];
        var allStmtTypes = match$4[0];
        var match$5 = React.useState(function () {
              return "all";
            });
        var setAllStmtTypesConcat = match$5[1];
        var allStmtTypesConcat = match$5[0];
        var match$6 = React.useState(function () {
              return Belt_HashMapInt.make(0);
            });
        var setTypeOrderInDisj = match$6[1];
        var match$7 = React.useState(function () {
              
            });
        var setIsAxiomFilter = match$7[1];
        var isAxiomFilter = match$7[0];
        var match$8 = React.useState(function () {
              
            });
        var setStmtTypeFilter = match$8[1];
        var stmtTypeFilter = match$8[0];
        var match$9 = React.useState(function () {
              return "";
            });
        var setLabelFilter = match$9[1];
        var labelFilter = match$9[0];
        var match$10 = React.useState(function () {
              return initPatternFilterStr;
            });
        var setPatternFilterStr = match$10[1];
        var patternFilterStr = match$10[0];
        var match$11 = React.useState(function () {
              
            });
        var setPatternFilterErr = match$11[1];
        var patternFilterErr = match$11[0];
        var match$12 = React.useState(function () {
              return "";
            });
        var setDescrFilterStr = match$12[1];
        var descrFilterStr = match$12[0];
        var match$13 = React.useState(function () {
              return false;
            });
        var setDiscFilter = match$13[1];
        var discFilter = match$13[0];
        var match$14 = React.useState(function () {
              return false;
            });
        var setDeprFilter = match$14[1];
        var deprFilter = match$14[0];
        var match$15 = React.useState(function () {
              return false;
            });
        var setTranDeprFilter = match$15[1];
        var tranDeprFilter = match$15[0];
        var match$16 = React.useState(function () {
              return false;
            });
        var setApplyFiltersRequested = match$16[1];
        var applyFiltersRequested = match$16[0];
        var match$17 = React.useState(function () {
              return false;
            });
        var setMainMenuIsOpened = match$17[1];
        var mainMenuIsOpened = match$17[0];
        var mainMenuButtonRef = React.useRef(null);
        var match$18 = Local_storage_utils.useStateFromLocalStorageInt("pe-index-asrts-per-page", 10);
        var setAsrtsPerPage = match$18[1];
        var asrtsPerPage = match$18[0];
        var actClearFilters = function (applyFilters) {
          setIsAxiomFilter(function (param) {
                
              });
          setStmtTypeFilter(function (param) {
                
              });
          setLabelFilter(function (param) {
                return "";
              });
          setPatternFilterStr(function (param) {
                return "";
              });
          setPatternFilterErr(function (param) {
                
              });
          setDescrFilterStr(function (param) {
                return "";
              });
          setDiscFilter(function (param) {
                return false;
              });
          setDeprFilter(function (param) {
                return false;
              });
          setTranDeprFilter(function (param) {
                return false;
              });
          if (applyFilters) {
            return setApplyFiltersRequested(function (param) {
                        return true;
                      });
          }
          
        };
        var actApplyFilters = function () {
          var searchPattern = MM_wrk_search_asrt.makeSearchPattern(patternFilterStr.trim(), preCtxData.ctxV.val);
          if (searchPattern.TAG === "Ok") {
            var searchPattern$1 = searchPattern._0;
            setPatternFilterErr(function (param) {
                  
                });
            var mapping = Belt_HashMapInt.make(10);
            var labelFilterTrim = labelFilter.trim().toLowerCase();
            var descrFilterStrTrim = descrFilterStr.trim().toLowerCase();
            var filterByDescr = descrFilterStrTrim.length > 0;
            return setFilteredLabels(function (param) {
                        return allLabels.filter(function (param) {
                                    var label = param[1];
                                    var frame = MM_context.getFrameExn(preCtxData.ctxV.val, label);
                                    if (Belt_Option.mapWithDefault(isAxiomFilter, true, (function (isAxiomFilter) {
                                              return isAxiomFilter === frame.isAxiom;
                                            })) && Belt_Option.mapWithDefault(stmtTypeFilter, true, (function (stmtType) {
                                              return stmtType === frame.asrt[0];
                                            })) && (!discFilter || frame.isDisc) && (!deprFilter || frame.isDepr) && (!tranDeprFilter || frame.isTranDepr) && label.toLowerCase().includes(labelFilterTrim) && (!filterByDescr || Belt_Option.mapWithDefault(frame.descr, false, (function (descr) {
                                                return descr.toLowerCase().includes(descrFilterStrTrim);
                                              })))) {
                                      return MM_wrk_search_asrt.frameMatchesPattern(frame, searchPattern$1, mapping);
                                    } else {
                                      return false;
                                    }
                                  });
                      });
          }
          var msg = searchPattern._0;
          setPatternFilterErr(function (param) {
                return msg;
              });
        };
        React.useEffect((function () {
                if (applyFiltersRequested) {
                  setApplyFiltersRequested(function (param) {
                        return false;
                      });
                  actApplyFilters();
                }
                
              }), [applyFiltersRequested]);
        var actPreCtxDataChanged = function (isFirstInvocation) {
          var settings = preCtxData.settingsV.val;
          setTypeColors(function (param) {
                return MM_wrk_settings.settingsGetTypeColors(settings);
              });
          var preCtx = preCtxData.ctxV.val;
          setPreCtxVer(function (param) {
                return preCtxData.ctxV.ver;
              });
          var allFrames = MM_context.getAllFrames(preCtx);
          var allLabels = new Array(Belt_MapString.size(allFrames));
          Belt_MapString.forEach(allFrames, (function (param, frame) {
                  allLabels[frame.ord] = [
                    frame.ord + 1 | 0,
                    frame.label
                  ];
                }));
          setAllLabels(function (param) {
                return allLabels;
              });
          setFilteredLabels(function (param) {
                return allLabels;
              });
          var allStmtIntTypes = [];
          MM_context.forEachFrame(preCtx, (function (frame) {
                  var stmtTyp = frame.asrt[0];
                  if (!allStmtIntTypes.includes(stmtTyp)) {
                    allStmtIntTypes.push(stmtTyp);
                  }
                  
                }));
          var allStmtTypes = MM_context.ctxIntsToSymsExn(preCtx, allStmtIntTypes).sort();
          setAllStmtTypes(function (param) {
                return allStmtTypes;
              });
          setAllStmtTypesConcat(function (param) {
                return "all" + allStmtTypes.join("");
              });
          var typeOrderInDisj = Common.createTypeOrderFromStr(settings.sortDisjByType, (function (__x) {
                  return MM_context.ctxSymToInt(preCtx, __x);
                }));
          setTypeOrderInDisj(function (param) {
                return typeOrderInDisj;
              });
          if (isFirstInvocation) {
            return setApplyFiltersRequested(function (param) {
                        return true;
                      });
          } else {
            return actClearFilters(false);
          }
        };
        var match$19 = React.useState(function () {
              return false;
            });
        var setPreCtxDataHasChangedPreviously = match$19[1];
        var preCtxDataHasChangedPreviously = match$19[0];
        React.useEffect((function () {
                actPreCtxDataChanged(!preCtxDataHasChangedPreviously);
                setPreCtxDataHasChangedPreviously(function (param) {
                      return true;
                    });
              }), [preCtxData]);
        var isAxiomFilterToStr = function (typeFilter) {
          if (typeFilter !== undefined) {
            if (typeFilter) {
              return "true";
            } else {
              return "false";
            }
          } else {
            return "none";
          }
        };
        var stmtTypeFilterToStr = function (typeFilter) {
          if (typeFilter !== undefined) {
            return MM_context.ctxIntToSymExn(preCtx, typeFilter);
          } else {
            return allStmtTypesConcat;
          }
        };
        var actIsAxiomFilterUpdated = function (isAxiomStr) {
          setIsAxiomFilter(function (param) {
                switch (isAxiomStr) {
                  case "false" :
                      return false;
                  case "true" :
                      return true;
                  default:
                    return ;
                }
              });
        };
        var actStmtTypeFilterUpdated = function (stmtTypeStr) {
          setStmtTypeFilter(function (param) {
                if (stmtTypeStr === allStmtTypesConcat) {
                  return ;
                } else {
                  return MM_context.ctxSymToInt(preCtx, stmtTypeStr);
                }
              });
        };
        var actLabelFilterUpdated = function (newLabelFilter) {
          setLabelFilter(function (param) {
                return newLabelFilter;
              });
        };
        var actPatternFilterStrUpdated = function (newPatternFilterStr) {
          setPatternFilterStr(function (param) {
                return newPatternFilterStr;
              });
        };
        var actDescrFilterStrUpdated = function (newDescrFilterStr) {
          setDescrFilterStr(function (param) {
                return newDescrFilterStr;
              });
        };
        var actDiscFilterUpdated = function (newDiscFilter) {
          setDiscFilter(function (param) {
                return newDiscFilter;
              });
        };
        var actDeprFilterUpdated = function (newDeprFilter) {
          setDeprFilter(function (param) {
                return newDeprFilter;
              });
        };
        var actTranDeprFilterUpdated = function (newTranDeprFilter) {
          setTranDeprFilter(function (param) {
                return newTranDeprFilter;
              });
        };
        var match$20 = React.useState(function () {
              return true;
            });
        var setIsFirstRender = match$20[1];
        var isFirstRender = match$20[0];
        React.useEffect((function () {
                setIsFirstRender(function (param) {
                      return false;
                    });
                if (!isFirstRender) {
                  actApplyFilters();
                }
                
              }), [
              isAxiomFilter,
              stmtTypeFilter,
              discFilter,
              deprFilter,
              tranDeprFilter
            ]);
        var actCloseMainMenu = function () {
          setMainMenuIsOpened(function (param) {
                return false;
              });
        };
        var actOpenAsrtsPerPageDialog = function () {
          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                      return null;
                    })), (function (modalId) {
                  Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                          return React.createElement(MM_cmp_asrts_per_page.make, {
                                      initAsrtsPerPage: String(asrtsPerPage),
                                      onOk: (function (strNum) {
                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                          var num = Belt_Int.fromString(strNum);
                                          if (num !== undefined) {
                                            return setAsrtsPerPage(function (param) {
                                                        return Math.max(1, Math.min(num, 100));
                                                      });
                                          }
                                          
                                        }),
                                      onCancel: (function () {
                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                        })
                                    });
                        }));
                }));
        };
        var rndIsAxiomFilter = function () {
          return React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(null)
                    }, React.createElement(InputLabel, {
                          id: "isAxiomFilter-label",
                          children: "Assertion type"
                        }), React.createElement(Select, {
                          sx: {
                            width: 130
                          },
                          labelId: "isAxiomFilter-label",
                          label: "Assertion type",
                          value: isAxiomFilterToStr(isAxiomFilter),
                          onChange: Expln_React_common.evt2str(actIsAxiomFilterUpdated),
                          children: Caml_option.some(null)
                        }, React.createElement(MenuItem, {
                              value: "none",
                              children: "All"
                            }), React.createElement(MenuItem, {
                              value: "true",
                              children: "Axiom"
                            }), React.createElement(MenuItem, {
                              value: "false",
                              children: "Theorem"
                            })));
        };
        var rndStmtTypeFilter = function () {
          return React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(null)
                    }, React.createElement(InputLabel, {
                          id: "stmtTypeFilter-label",
                          children: "Statement type"
                        }), React.createElement(Select, {
                          sx: {
                            width: 130
                          },
                          labelId: "stmtTypeFilter-label",
                          label: "Statement type",
                          value: stmtTypeFilterToStr(stmtTypeFilter),
                          onChange: Expln_React_common.evt2str(actStmtTypeFilterUpdated),
                          children: Caml_option.some(null)
                        }, React.createElement(MenuItem, {
                              value: allStmtTypesConcat,
                              children: "All"
                            }), allStmtTypes.map(function (stmtType) {
                              return JsxPPXReactSupportU.createElementWithKey(stmtType, MenuItem, {
                                          value: stmtType,
                                          children: Caml_option.some(stmtType)
                                        });
                            })));
        };
        var rndLabelFilter = function () {
          return React.createElement(TextField, {
                      value: labelFilter,
                      label: "Label",
                      size: "small",
                      style: {
                        width: "200px"
                      },
                      onChange: Expln_React_common.evt2str(actLabelFilterUpdated),
                      onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actApplyFilters),
                      autoFocus: true
                    });
        };
        var rndPatternFilter = function () {
          return React.createElement(TextField, {
                      value: patternFilterStr,
                      label: "Pattern",
                      size: "small",
                      style: {
                        width: "300px"
                      },
                      onChange: Expln_React_common.evt2str(actPatternFilterStrUpdated),
                      onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actApplyFilters)
                    });
        };
        var rndDescrFilter = function () {
          return React.createElement(TextField, {
                      value: descrFilterStr,
                      label: "Description",
                      size: "small",
                      style: {
                        width: "300px"
                      },
                      onChange: Expln_React_common.evt2str(actDescrFilterStrUpdated),
                      onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actApplyFilters)
                    });
        };
        var rndPatternError = function () {
          if (patternFilterErr !== undefined) {
            return React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, "Malformed pattern text: " + patternFilterErr);
          } else {
            return React.createElement(React.Fragment, {});
          }
        };
        var rndDiscFilter = function () {
          return React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: discFilter,
                            onChange: Expln_React_common.evt2bool(actDiscFilterUpdated)
                          }),
                      label: "Discouraged",
                      style: {
                        marginTop: "-2px",
                        marginLeft: "2px",
                        paddingRight: "10px"
                      }
                    });
        };
        var rndDeprFilter = function () {
          return React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: deprFilter,
                            onChange: Expln_React_common.evt2bool(actDeprFilterUpdated)
                          }),
                      label: "Deprecated",
                      style: {
                        marginTop: "-2px",
                        marginLeft: "2px",
                        paddingRight: "10px"
                      }
                    });
        };
        var rndTranDeprFilter = function () {
          return React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: tranDeprFilter,
                            onChange: Expln_React_common.evt2bool(actTranDeprFilterUpdated)
                          }),
                      label: "Transitively deprecated",
                      style: {
                        marginTop: "-2px",
                        marginLeft: "2px",
                        paddingRight: "10px"
                      }
                    });
        };
        var rndApplyFiltersBtn = function () {
          return React.createElement("span", {
                      title: "Apply filters"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              actApplyFilters();
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(FilterAlt, {}))
                        }));
        };
        var rndClearFiltersBtn = function () {
          return React.createElement("span", {
                      title: "Clear filters"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              actClearFilters(true);
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(FilterAltOff, {}))
                        }));
        };
        var rndMainMenuBtn = function () {
          return React.createElement("span", {
                      ref: Caml_option.some(mainMenuButtonRef),
                      title: "Additional actions"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              setMainMenuIsOpened(function (param) {
                                    return true;
                                  });
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(Menu, {}))
                        }));
        };
        var rndFilters = function () {
          return React.createElement(Expln_React_Column.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(Expln_React_Row.make, {
                          children: Caml_option.some(null)
                        }, rndIsAxiomFilter(), rndLabelFilter(), rndPatternFilter(), rndDescrFilter(), rndApplyFiltersBtn(), rndClearFiltersBtn(), rndMainMenuBtn()), React.createElement(Expln_React_Row.make, {
                          children: Caml_option.some(null)
                        }, rndStmtTypeFilter(), rndDiscFilter(), rndDeprFilter(), rndTranDeprFilter()));
        };
        var rndMainMenu = function () {
          if (!mainMenuIsOpened) {
            return React.createElement(React.Fragment, {});
          }
          var mainMenuButtonRef$1 = mainMenuButtonRef.current;
          if (mainMenuButtonRef$1 == null) {
            return React.createElement(React.Fragment, {});
          } else {
            return React.createElement(Expln_React_Menu.make, {
                        opn: true,
                        anchorEl: Caml_option.some(mainMenuButtonRef$1),
                        onClose: actCloseMainMenu,
                        children: Caml_option.some(null)
                      }, React.createElement(MenuItem, {
                            onClick: (function () {
                                setMainMenuIsOpened(function (param) {
                                      return false;
                                    });
                                openExplorer("");
                              }),
                            children: "Open new Explorer tab"
                          }), React.createElement(MenuItem, {
                            onClick: (function () {
                                setMainMenuIsOpened(function (param) {
                                      return false;
                                    });
                                Belt_Option.forEach(Caml_option.nullable_to_opt(toggleCtxSelector.current), (function (toggleCtxSelector) {
                                        toggleCtxSelector();
                                      }));
                              }),
                            children: Caml_option.some(ctxSelectorIsExpanded ? "Hide context" : "Show context")
                          }), React.createElement(MenuItem, {
                            onClick: (function () {
                                setMainMenuIsOpened(function (param) {
                                      return false;
                                    });
                                actOpenAsrtsPerPageDialog();
                              }),
                            children: Caml_option.some("Assertions per page: " + String(asrtsPerPage))
                          }));
          }
        };
        return React.createElement(Expln_React_Column.make, {
                    style: {
                      margin: "15px"
                    },
                    children: Caml_option.some(null)
                  }, rndFilters(), rndPatternError(), rndMainMenu(), JsxPPXReactSupportU.createElementWithKey(String(match[0]), MM_cmp_pe_frame_list.make, {
                        modalRef: modalRef,
                        typeColors: match$1[0],
                        editStmtsByLeftClick: settings.editStmtsByLeftClick,
                        settings: preCtxData.settingsV.val,
                        preCtx: preCtx,
                        frms: preCtxData.frms,
                        parenCnt: preCtxData.parenCnt,
                        syntaxTypes: preCtxData.syntaxTypes,
                        typeOrderInDisj: match$6[0],
                        labels: match$3[0],
                        openFrameExplorer: param.openFrameExplorer,
                        openExplorer: openExplorer,
                        asrtsPerPage: asrtsPerPage,
                        addAsrtByLabel: (function (label) {
                            var addAsrtByLabel$1 = addAsrtByLabel.current;
                            if (addAsrtByLabel$1 == null) {
                              return Promise.resolve({
                                          TAG: "Error",
                                          _0: "Internal error: addAsrtByLabel is null"
                                        });
                            } else {
                              return addAsrtByLabel$1(label);
                            }
                          })
                      }));
      }), propsAreSame);

exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
